import { useState, type FormEvent } from 'react';
import { api, type Me, type Member, type Project } from '../api.js';
import { href, navigate } from '../router.js';

export function Members({ project, me, onChange }: { project: Project; me: Me; onChange: (p: Project) => void }) {
  const owner = project.role === 'owner';
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [confirm, setConfirm] = useState(false);
  const run = async (fn: () => Promise<void>) => {
    setError('');
    try {
      await fn();
    } catch (e) {
      setError((e as Error).message);
    }
  };
  const setMembers = (members: Member[]) => onChange({ ...project, members });
  const add = (e: FormEvent) => {
    e.preventDefault();
    void run(async () => {
      setMembers((await api<{ members: Member[] }>('POST', `/api/projects/${project.id}/members`, { email })).members);
      setEmail('');
    });
  };
  const saveDetails = (title: string, timeWindow: string) =>
    run(async () => onChange({ ...project, ...(await api<Project>('PATCH', `/api/projects/${project.id}`, { title, timeWindow })) }));

  return (
    <section className="members">
      <h2>Project</h2>
      <form
        className="details"
        onSubmit={(e) => {
          e.preventDefault();
          const f = new FormData(e.currentTarget);
          void saveDetails(String(f.get('title')), String(f.get('timeWindow')));
        }}
      >
        <label>Title <input name="title" defaultValue={project.title} required /></label>
        <label>When <input name="timeWindow" defaultValue={project.timeWindow} /></label>
        <button type="submit">Save</button>
      </form>
      <h2>Members</h2>
      <ul>
        {project.members.map((m) => (
          <li key={m.id}>
            {m.name} <small>{m.email}</small> {m.role === 'owner' && <em>owner</em>}
            {owner && m.role !== 'owner' && (
              <button className="link small" onClick={() => run(async () => setMembers((await api<{ members: Member[] }>('DELETE', `/api/projects/${project.id}/members/${m.id}`)).members))}>
                Remove
              </button>
            )}
          </li>
        ))}
      </ul>
      {owner && (
        <form onSubmit={add} className="add-member">
          <input type="email" aria-label="Member e-mail" placeholder="kostis@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <button type="submit">Add member</button>
        </form>
      )}
      {error && <p className="error" role="alert">{error}</p>}
      {owner && (
        <div className="danger-zone">
          {confirm ? (
            <>
              <span>Delete “{project.title}” for everyone?</span>
              <button className="danger" onClick={() => run(async () => { await api('DELETE', `/api/projects/${project.id}`); navigate(href.projects()); })}>Delete project</button>
              <button className="link" onClick={() => setConfirm(false)}>Keep</button>
            </>
          ) : (
            <button className="link danger" onClick={() => setConfirm(true)}>Delete project…</button>
          )}
        </div>
      )}
      <p className="muted">Signed in as {me.name}.</p>
    </section>
  );
}
